import {
  FILTERED_OUTPUT_DATA_REQUEST,
  FILTERED_OUTPUT_DATA_SUCCESS,
  FILTERED_OUTPUT_DATA_FAILURE,
} from "./filteredOutputDataType";
const initialState = {
  success: false,
  loading: false,
  outputData: [],
  error: "",
};
const filteredOutputDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTERED_OUTPUT_DATA_REQUEST:
      return {
        ...state,
        success: false,
        loading: action.loading,
      };
    case FILTERED_OUTPUT_DATA_SUCCESS:
      const setSignUpState = {
        ...state,
        success: true,
        loading: action.loading,
        outputData: action.payload,
        error: "",
      };
      return setSignUpState;
    case FILTERED_OUTPUT_DATA_FAILURE:
      return {
        ...state,
        success: false,
        loading: action.loading,
        outputData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default filteredOutputDataReducer;
